import { v4 as uuidv4 } from "uuid";
import { Currency } from "shared/enums/CurrencyEnum";
import { getConfiguration } from "./ConfigUtility";

export const GetNewId = () => {
  return uuidv4();
};

export const GetEnumKeys = (MyEnum: any) => {
  return Object.keys(MyEnum)
    .map((key: any) => MyEnum[key])
    .filter((value) => typeof value === "string") as string[];
};

export const GetEnumKeyValues = (MyEnum: any) => {
  const keyValues: { key: string; value: number }[] = [];
  for (let status in MyEnum) {
    const value = Number(status);
    if (!isNaN(value)) {
      keyValues.push({
        key: MyEnum[value],
        value: value,
      });
    }
  }
  return keyValues;
};

export const copyTextToClipboard = (textToCopy: string) => {
  const el = document.createElement("textarea");
  el.value = textToCopy;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

export const getCurrencySymbol = (currency?: Currency, useDefaultCurrencyIfNotAvailable = true) => {
  if(!currency && useDefaultCurrencyIfNotAvailable){
    const defaultCurrency = getConfiguration("defaultCurrency");
    currency =  defaultCurrency;
  }

  return currency === Currency.EUR ? "€" : "$";
};

export const getPriceWithCurrencySymbol = (
  price: string | number,
  currency: Currency = Currency.EUR
) => {
  return `${getCurrencySymbol(currency)}${price}`;
};

export const isNumber = (text: string) => {
  return !isNaN(Number(text));
};

export const getAppUrl = (path: string) => {
  const origin = window.location.origin;
  return `${origin}${path.startsWith("/") ? "" : "/"}${path}`;
};

export const isSame = (obj1: object, obj2: object) => {
  return Object.entries(obj1).toString() === Object.entries(obj2).toString();
};

export const isValidEmail = (email: string) => {
  const regex = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
  return regex.test(email);
};
